// --------------------------------------------
// 📄 SaleCustomerReportTabs.js — FINAL VERSION
// --------------------------------------------
import React, { useEffect, useState } from "react";
import api from "../../../utils/axios";
import moment from "moment";
import "moment/locale/th";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Pagination from "../../components/Pagination";
import DatePicker from "../../components/DatePicker";

export default function SaleCustomerReportTabs() {
  const [callData, setCallData] = useState([]);
  const [appointData, setAppointData] = useState([]);

  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState(""); // ⭐ restore ได้

  // pagination เดียว
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);

  const [callSortField, setCallSortField] = useState(null);
  const [callSortDirection, setCallSortDirection] = useState("asc");

  const [appointSortField, setAppointSortField] = useState(null);
  const [appointSortDirection, setAppointSortDirection] = useState("asc");



  const breadcrumbs = [
    { label: "ขาย", link: "/sale" },
    { label: "รายงานการติดต่อลูกค้า" },
  ];

  // --------------------------------------------
  // 🔵 โหลด Call + Appointment
  // --------------------------------------------
  const fetchAllData = async (date) => {
    setLoading(true);
    try {
      const [callRes, appointRes] = await Promise.all([
        api.get(`/get-sale-call-summary?date=${date}`),
        api.get(`/get-sale-appoint-summary?date=${date}`),
      ]);

      setCallData(callRes.data?.result || []);
      setAppointData(appointRes.data?.result || []);
    } catch (err) {
      Swal.fire("ผิดพลาด", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------
  // 🚀 INITIAL LOAD + RESTORE SEARCH & DATE
  // --------------------------------------------
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    const savedDate = localStorage.getItem("saleReportDate");
    const savedSearch = localStorage.getItem("saleReportSearch");

    const dateToUse = savedDate || today;

    setSelectedDate(dateToUse);
    setSearchText(savedSearch || "");   // ⭐ restore search

    fetchAllData(dateToUse);
  }, []);

  // --------------------------------------------
  // 📌 Format Thai Date
  // --------------------------------------------
  const formatThaiDate = (date) => {
    if (!date) return "-";
    const m = moment.utc(date);
    return m.format(`DD/MMM/${m.year() + 543}`);
  };

  const formatThaiDateTime = (date) => {
    if (!date) return "-";
    const m = moment.utc(date);
    return m.format(`DD/MMM/${m.year() + 543}, HH:mm`);
  };

  const sortCallData = (data) => {
    if (!callSortField) return data;

    return [...data].sort((a, b) => {
      let x = a[callSortField];
      let y = b[callSortField];

      if (callSortField === "LastCallDate") {
        x = x ? new Date(x).getTime() : 0;
        y = y ? new Date(y).getTime() : 0;
      }

      if (typeof x === "string") x = x.toLowerCase();
      if (typeof y === "string") y = y.toLowerCase();

      if (x < y) return callSortDirection === "asc" ? -1 : 1;
      if (x > y) return callSortDirection === "asc" ? 1 : -1;
      return 0;
    });
  };

  const sortAppointData = (data) => {
    if (!appointSortField) return data;

    return [...data].sort((a, b) => {
      let x = a[appointSortField];
      let y = b[appointSortField];

      if (appointSortField === "LastAppointDate") {
        x = x ? new Date(x).getTime() : 0;
        y = y ? new Date(y).getTime() : 0;
      }

      if (typeof x === "string") x = x.toLowerCase();
      if (typeof y === "string") y = y.toLowerCase();

      if (x < y) return appointSortDirection === "asc" ? -1 : 1;
      if (x > y) return appointSortDirection === "asc" ? 1 : -1;
      return 0;
    });
  };



  const handleSortCall = (field) => {
    if (callSortField === field) {
      setCallSortDirection(callSortDirection === "asc" ? "desc" : "asc");
    } else {
      setCallSortField(field);
      setCallSortDirection("asc");
    }
  };

  const handleSortAppoint = (field) => {
    if (appointSortField === field) {
      setAppointSortDirection(appointSortDirection === "asc" ? "desc" : "asc");
    } else {
      setAppointSortField(field);
      setAppointSortDirection("asc");
    }
  };



  const filteredCall = sortCallData(
    callData.filter(d =>
      d.Emp_Name?.toLowerCase().includes(searchText.toLowerCase())
    )
  );



  const filteredAppoint = sortAppointData(
    appointData
      .filter(d =>
        d.Emp_Name?.toLowerCase().includes(searchText.toLowerCase())
      )
      .map((item, i) => ({ ...item, index: i + 1 }))
  );




  // --------------------------------------------
  // 📄 Pagination รวม
  // --------------------------------------------
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedCall = filteredCall.slice(startIndex, startIndex + itemsPerPage);
  const paginatedAppoint = filteredAppoint.slice(startIndex, startIndex + itemsPerPage);  

  return (
    <>
      <Sidebar />
      <Topbar className="pl-0" breadcrumbs={breadcrumbs} />

      <div
        className="pl-2 pr-8 pt-3 pb-6"
        style={{
          marginLeft: "var(--sidebar-width)",
          marginTop: "40px",
          backgroundColor: "#f8f9fa",
          minHeight: "calc(100vh - 40px)",
        }}
      >
        <div className="card border-0 shadow-sm p-3">

          <style>{`
            * { font-size: 14px !important; }

            table.table {
              border-collapse: collapse;
              width: 100%;
            }

            th, td {
              text-align: center !important;
              vertical-align: middle !important;
              border: 1px solid #ccc !important;
              padding: 6px 10px !important;
              white-space: nowrap;
            }

            thead th {
              background-color: #E13F57 !important;
              color: white !important;
              font-weight: 600;
            }

            tbody tr:nth-child(odd) { background: #fafafa; }
            tbody tr:nth-child(even) { background: #fff; }
            tbody tr:hover { background: #f5f7ff !important; }

            table.appoint-table thead th {
              background-color: #1E88E5 !important;
              color: white !important;
            }
          `}</style>

          <div className="row mb-3">
            <div className="col-12">
              <div className="d-flex align-items-center flex-wrap gap-2">

                {/* SEARCH */}
                <input
                  type="text"
                  placeholder="ค้นหาพนักงาน..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    localStorage.setItem("saleReportSearch", e.target.value);
                  }}
                  className="form-control"
                  style={{ width: "220px" }}
                />

                {/* PREV DAY */}
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "38px", padding: 0 }}
                  onClick={() => {
                    const prev = moment(selectedDate)
                      .subtract(1, "day")
                      .format("YYYY-MM-DD");
                    setSelectedDate(prev);
                    localStorage.setItem("saleReportDate", prev);
                    fetchAllData(prev);
                  }}
                >
                  ◀
                </button>

                {/* DATE PICKER */}
                <div
                  style={{
                    minWidth: "230px",   // ⭐ ความกว้างที่ต้องการ
                    flexShrink: 0,       // ⭐ ไม่ให้บีบ
                  }}
                >
                  <DatePicker
                    name="selectedDate"
                    value={selectedDate}
                    onChange={(newDate) => {
                      setSelectedDate(newDate);
                      localStorage.setItem("saleReportDate", newDate);
                      fetchAllData(newDate);
                    }}
                    disabled={loading}
                    className="form-control datepicker-fix"
                  />
                </div>




                {/* NEXT DAY */}
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  style={{ width: "40px", height: "38px", padding: 0 }}
                  onClick={() => {
                    const next = moment(selectedDate)
                      .add(1, "day")
                      .format("YYYY-MM-DD");
                    setSelectedDate(next);
                    localStorage.setItem("saleReportDate", next);
                    fetchAllData(next);
                  }}
                >
                  ▶
                </button>

                {/* RESET */}
                <button
                  className="btn btn-outline-danger"
                  style={{ padding: "0 18px", height: "38px" }}
                  onClick={() => {
                    const today = new Date().toISOString().split("T")[0];
                    setSelectedDate(today);
                    setSearchText("");
                    localStorage.removeItem("saleReportDate");
                    localStorage.removeItem("saleReportSearch");
                    fetchAllData(today);
                  }}
                >
                  รีเซ็ต
                </button>

              </div>
            </div>
          </div>

          <div className="row">

            {/* LEFT — CALL */}
            <div className="col-md-6">

              <div
                className="fw-bold text-white text-center mb-2"
                style={{
                  backgroundColor: "#E13F57",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  fontSize: "15px",
                  width: "260px",
                }}
              >
                รายงานบันทึกการโทรหาลูกค้า
              </div>

              <div className="card shadow-sm mb-3">
                <div className="table-responsive" style={{ maxHeight: "60vh" }}>
                  <table className="table table-bordered table-hover mb-0">
                    <thead>
                      <tr>
                        <th onClick={() => handleSortCall("index")} style={{cursor:"pointer"}}>
                          ลำดับ
                          {callSortField === "index" && (callSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>
                        <th onClick={() => handleSortCall("Emp_Name")} style={{cursor:"pointer"}}>
                          พนักงานขาย
                          {callSortField === "Emp_Name" && (callSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                        <th onClick={() => handleSortCall("TotalCalls")} style={{cursor:"pointer"}}>
                          จำนวนครั้งที่โทร
                          {callSortField === "TotalCalls" && (callSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                        <th onClick={() => handleSortCall("LastCallDate")} style={{cursor:"pointer"}}>
                          วันที่โทรล่าสุด
                          {callSortField === "LastCallDate" && (callSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center py-3">กำลังโหลด...</td>
                        </tr>
                      ) : paginatedCall.length > 0 ? (
                        paginatedCall.map((row, idx) => (
                          <tr key={row.Emp_Id}>
                            <td>{startIndex + idx + 1}</td>

                            <td className="text-start text-primary fw-semibold">
                              <Link to={`/sale-call-detail/${row.Emp_Id}?date=${selectedDate}`}>
                                {row.Emp_Name}
                              </Link>
                            </td>

                            <td>{row.TotalCalls}</td>
                            <td className="text-center">
                              {row.LastCallResult === "-" 
                                ? "-" 
                                : row.LastCallDate 
                                    ? formatThaiDateTime(row.LastCallDate)
                                    : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-3 text-muted">ไม่พบข้อมูล</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-6">

              <div
                className="fw-bold text-white text-center mb-2"
                style={{
                  backgroundColor: "#1E88E5",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  fontSize: "15px",
                  width: "260px",
                }}
              >
                รายงานบันทึกการนัดหมายเข้าพบ
              </div>

              <div className="card shadow-sm mb-3">
                <div className="table-responsive" style={{ maxHeight: "60vh" }}>
                  <table className="table table-bordered table-hover mb-0 appoint-table">
                    <thead>
                      <tr>
                        <th onClick={() => handleSortAppoint("index")} style={{ cursor: "pointer" }}>
                          ลำดับ
                          {appointSortField  === "index" && (appointSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                        <th onClick={() => handleSortAppoint("Emp_Name")} style={{ cursor: "pointer" }}>
                          พนักงานขาย
                          {appointSortField  === "Emp_Name" && (appointSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                        <th onClick={() => handleSortAppoint("TotalAppoints")} style={{ cursor: "pointer" }}>
                          จำนวนครั้งที่เข้าพบ
                          {appointSortField  === "TotalAppoints" && (appointSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                        <th onClick={() => handleSortAppoint("LastAppointDate")} style={{ cursor: "pointer" }}>
                          วันที่เข้าพบล่าสุด
                          {appointSortField  === "LastAppointDate" && (appointSortDirection === "asc" ? " ▲" : " ▼")}
                        </th>

                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center py-3">กำลังโหลด...</td>
                        </tr>
                      ) : paginatedAppoint.length > 0 ? (
                        paginatedAppoint.map((row, idx) => (
                          <tr key={row.Emp_Id}>
                            <td>{startIndex + idx + 1}</td>

                            <td className="text-start text-primary fw-semibold">
                              <Link to={`/sale-appoint-detail/${row.Emp_Id}?date=${selectedDate}`}>
                                {row.Emp_Name}
                              </Link>
                            </td>

                            <td>{row.TotalAppoints}</td>

                            <td>
                              {(() => {
                                if (!row.LastAppointDate) return "-";

                                let dateText = formatThaiDate(row.LastAppointDate);

                                let times = [];
                                try {
                                  times = JSON.parse(row.AppointTimes || "[]");
                                } catch {}

                                if (times.length === 0) return dateText;

                                times.sort((a, b) => (b.Time_Start > a.Time_Start ? 1 : -1));

                                const t = times[0];
                                const start = t.Time_Start?.substring(0, 5);
                                const end = t.Time_End?.substring(0, 5);

                                return `${dateText} ${start} - ${end}`;
                              })()}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-3 text-muted">ไม่พบข้อมูล</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>

          <div className="p-2 border-top bg-white">
            <Pagination
              totalItems={Math.max(filteredCall.length, filteredAppoint.length)}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={setItemsPerPage}
            />
          </div>

        </div>
      </div>
    </>
  );
}
